import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { VatDto } from "../../../../dtos/catalogs/Vat/VatDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import VatDetailSkeleton from "./VatDetailSkeleton";
import { VatTypeEnum } from "../../../../enums/VatTypeEnum";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { useTranslation } from "react-i18next";

interface IProps {
  model: VatDto | null;
  modelUpdatedEvent: (newModel: VatDto) => void;
}

interface VatModel {
  name?: string;
  id: string;
  createdDate?: Date;
  uniqueCode?: string;
  vatType?: number;
}

export const VatDetail = ({ model, modelUpdatedEvent }: IProps) => {
    const {t} = useTranslation()
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<VatModel>();

  const VatType = [
    {
      id: VatTypeEnum.Vat0,
      name: "0%"
    },
    {
      id: VatTypeEnum.VatNo,
      name: "Tax free"
    },

    {
      id: VatTypeEnum.Vat18,
      name: "18%"
    },
    {
      id: VatTypeEnum.Other,
      name: "Other"
    }
  ];
  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("name", model.name);
      setValue("createdDate", model.createdDate);
      setValue("uniqueCode", model.uniqueCode);
      setValue("vatType", model.vatType);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: VatModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: VatDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <VatDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={t("Name")} fieldName={"name"} />
            </Col>
            <Col sm={3}>
              <NFDateInput title={t("created date")} fieldName="createdDate" />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupInput title={t("Rate")} fieldName={"vatType"} items={VatType} />
            </Col>
            <Col sm={6}>{watch("vatType") === VatTypeEnum.Other && <NFIntInput title={t("VAT Rate")} fieldName={"vatRate"} />}</Col>
            <Col sm={6}>
              <NFTextInput title={t("Unique code")} fieldName={"uniqueCode"} />
            </Col>
          </Row>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
